export default __webpack_public_path__ + "static/media/25_DMG.0aa8dc82.png";